import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, toRefs } from 'vue';

// Stores
import { useUiStore } from 'src/stores/ui';

// ViewModel
import { useGlobalVM } from '@viewmodel/global.vm';

// PERSONAL COMPONENTS
import QBtnValid from '@components/form/QBtnValid.vue';
import QBtnCancel from '@components/form/QBtnCancel.vue';
import QDialogTemplate from '@components/template/QDialogTemplate.vue';

// PERSONAL LIBS
import { tailleFichier } from '@shared/lib/tools.lib';

/**
 * Events
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'DialogVideoRules',
  props: {
  show: { type: Boolean, required: true, default: false },
},
  emits: ['close', 'success', 'failed'],
  setup(__props, { emit: __emit }) {

// VENDOR
const emits = __emit;

/**
 * Stores
 */
const uiStore = useUiStore();

/**
 * Viewmodel
 */
const { isMobile } = useGlobalVM();

/**
 * Reactive datas
 */
const loading = ref<boolean>(false);

/**
 * Computed properties
 */
const maxFileSize = computed<number>(() => {
  return uiStore.config?.uploader?.maxFileSize != null
    ? uiStore.config.uploader.maxFileSize
    : 0;
});

/**
 * Properties
 */
const props = __props;
const { show } = toRefs(props);

/**
 * Methods
 */
function onClose() {
  emits('close');
}

function onSuccess() {
  emits('success');
}

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!

  return (_openBlock(), _createBlock(QDialogTemplate, {
    "show-dialog": _unref(show),
    title: "Règles de dépôt des vidéos",
    maximized: _unref(isMobile),
    persistent: loading.value,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (onClose()))
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card, {
        flat: "",
        class: "no-border-radius q-pt-sm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("p", { class: "q-mb-none" }, " Avant de dépôser une vidéo sur l'application, vous devez accepter de respecter les règles suivantes : ", -1 /* HOISTED */),
              _createElementVNode("ul", { class: "q-mb-none" }, [
                _createElementVNode("li", null, "Tenue : Kobudo"),
                _createElementVNode("li", null, " Lieu : dojo ou extérieur (aucun autre endroit ne sera accepté) "),
                _createElementVNode("li", null, "Orientation de la vidéo : paysage"),
                _createElementVNode("li", null, "Formats autorisés : MP4, MPEG"),
                _createElementVNode("li", null, "Encodage de la vidéo : sur VLC, profil \"Video for Android HD\" en désactivant le codec audio"),
                _createElementVNode("li", null, "Taille recommandée pour la vidéo : moins de 50 Mo")
              ], -1 /* HOISTED */)
            ])),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_q_card, {
        flat: "",
        class: "no-border-radius"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_separator),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _createVNode(QBtnCancel, {
                label: 'Refuser les règles',
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onClose())),
                disable: loading.value
              }, null, 8 /* PROPS */, ["disable"]),
              _createVNode(QBtnValid, {
                label: 'Accepter les règles',
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onSuccess())),
                disable: loading.value
              }, null, 8 /* PROPS */, ["disable"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-dialog", "maximized", "persistent"]))
}
}

})